var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewSegmentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view-segmentation",
    transform: "translate(-1337 -153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 24,
    height: 24,
    transform: "translate(1337 153)",
    fill: "#398aff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M19,5V7H15V5h4M9,5v6H5V5H9m10,8v6H15V13h4M9,17v2H5V17H9M21,3H13V9h8V3M11,3H3V13h8V3m10,8H13V21h8V11M11,15H3v6h8Z",
    transform: "translate(1337 153)",
    fill: "#398aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6009-2",
    "data-name": "Path 6009",
    d: "M19,5V7H15V5h4M9,5v6H5V5H9m10,8v6H15V13h4M9,17v2H5V17H9M21,3H13V9h8V3M11,3H3V13h8V3m10,8H13V21h8V11M11,15H3v6h8Z",
    transform: "translate(1337 153)",
    fill: "#398aff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSegmentation);
export default __webpack_public_path__ + "static/media/view-segmentation.66c9adf16d751260e4c3f6ba9c7849bd.svg";
export { ForwardRef as ReactComponent };